module.exports = __webpack_public_path__ + "static/media/mg-wx.5f879881.png";